import React, { Fragment, useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../../layout/breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import withReducer from "../../../../store/withReducer";
import productReducer from "../../../manage-product/store";
import Select, { components } from "react-select";
import { sellerBrandSuggestionApi, getPriceReductionFilterOptionsApi, getPriceReductionRequestDetailsApi, approvePriceReductionRequestApi, declinePriceReductionRequestApi } from "../../../../services/manage-product/productService";
import { getProductTagApi } from "../../../../services/manage-product/setting/productTagService";
import moment from "moment";
import { toast } from "react-toastify";

const dataMenu = [
  {
    type: 1,
    text: "Price Reduction Requests",
    link: "/product/price-reductions-request",
  },
  {
    type: 0,
    text: "View",
  },
];

const ProductTagSelector = ({ 
  productId, 
  selectedTags, 
  tagOptions, 
  onTagChange, 
  onCreateTag,
  isDisabled = false
}) => {
  const customOptions = [
    {
      value: '__add_new__',
      label: 'Add new tag',
      isAddNew: true
    },
    ...(tagOptions || [])
  ];

  return (
    <div className="product-tag-selector-wrapper">
      <Select
        className="select2-filter product-tag-selector"
        isClearable
        isMulti
        isSearchable
        isDisabled={isDisabled}
        placeholder="Select Tag"
        value={selectedTags}
        options={customOptions}
      getOptionLabel={(option) => option.name || option.label || ''}
      getOptionValue={(option) => String(option.value || option.id || '')}
      isOptionEqualToValue={(option, value) => {
        const optionVal = String(option.value || option.id || '');
        const valueVal = String(value.value || value.id || '');
        return optionVal === valueVal && optionVal !== '';
      }}
      menuPortalTarget={document.body}
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: 38,
          maxHeight: 80,
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          backgroundColor: state.isDisabled ? '#f5f5f5' : '#ffffff',
          boxShadow: 'none',
          cursor: state.isDisabled ? 'default' : 'pointer',
          overflow: 'visible',
          pointerEvents: state.isDisabled ? 'auto' : 'auto',
          '&:hover': {
            border: '1px solid #e0e0e0',
          },
        }),
        placeholder: (base) => ({
          ...base,
          color: '#9e9e9e',
          fontSize: '12px',
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: '12px',
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: '#e0e0e0',
          borderRadius: '4px',
          fontSize: '12px',
          maxWidth: '180px',
          margin: '2px',
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: '#333',
          fontSize: '12px',
          padding: '2px 6px',
        }),
        multiValueRemove: (base) => ({
          ...base,
          color: '#666',
          '&:hover': {
            backgroundColor: '#d0d0d0',
            color: '#333',
          },
        }),
        valueContainer: (base, state) => ({
          ...base,
          padding: '4px 12px',
          minHeight: '36px',
          maxHeight: '80px',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexWrap: 'wrap',
          WebkitOverflowScrolling: 'touch',
          pointerEvents: 'auto',
          cursor: state.isDisabled ? 'default' : 'text',
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: '36px',
        }),
        indicatorSeparator: (base) => ({
          ...base,
          backgroundColor: '#e0e0e0',
          width: '1px',
          marginTop: '0px',
          marginBottom: '0px',
          alignSelf: 'stretch',
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: '#9e9e9e',
          padding: '4px 8px',
          '&:hover': {
            color: '#9e9e9e',
          },
        }),
        menuPortal: (base) => ({ ...base, zIndex: 100 }),
        menu: (base) => ({
          ...base,
          zIndex: 100,
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? '#f0f0f0' : state.isSelected ? '#e0e0e0' : '#ffffff',
          color: state.isSelected ? '#333' : state.isDisabled ? '#999' : '#666',
          fontSize: '12px',
          padding: '8px 12px',
          cursor: 'pointer',
          '&:active': {
            backgroundColor: state.isDisabled ? '#f0f0f0' : '#e0e0e0',
          },
        }),
      }}
      onChange={(selected) => {
        if (selected && Array.isArray(selected)) {
          const filtered = selected.filter(opt => opt.value !== '__add_new__' && opt.id !== '__add_new__');
          onTagChange(productId, filtered);
        } else {
          onTagChange(productId, selected || []);
        }
      }}
      components={{
        Option: (props) => {
          const { data, innerRef, innerProps } = props;
          if (data.value === '__add_new__' || data.id === '__add_new__') {
            return (
              <div
                ref={innerRef}
                {...innerProps}
                style={{
                  ...props.getStyles('option', props),
                  padding: '8px 12px',
                  cursor: 'pointer',
                  backgroundColor: props.isFocused ? '#f0f0f0' : '#ffffff',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onCreateTag();
                  return false;
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f0f0f0';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#ffffff';
                }}
              >
                <i className="fa fa-plus" style={{ marginRight: '8px', fontSize: '12px' }}></i>
                Add new tag
              </div>
            );
          }
          return <components.Option {...props} />;
        }
      }}
      />
    </div>
  );
};

const PriceReductionRequestView = () => {
  const { id } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [variantDiscounts, setVariantDiscounts] = useState({});
  const [activeTab, setActiveTab] = useState("pending");
  const [priceReduction, setPriceReduction] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [globalDiscount, setGlobalDiscount] = useState('');
  const [globalTags, setGlobalTags] = useState([]);
  const [productTagOptions, setProductTagOptions] = useState([]);
  const [approveLoading, setApproveLoading] = useState(false);
  const [declineLoading, setDeclineLoading] = useState(false);

  const [filterBrand, setFilterBrand] = useState(null);
  const [filterCategory, setFilterCategory] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filterOptions, setFilterOptions] = useState({ categories: [], brands: [] });

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 50,
      border: "none",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 100 }),
  };

  const brandPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      sellerBrandSuggestionApi({ search: inputValue }).then((res) => {
        const options = (res.response.data || []).map((item) => ({
          value: item.id,
          label: item.name,
        }));
        resolve(options);
      });
    });

  useEffect(() => {
    getPriceReductionFilterOptionsApi().then((res) => {
      if (res.response) {
        setFilterOptions({
          categories: res.response.categories || [],
          brands: res.response.brands || [],
        });
      }
    });
    fetchProductTags();
  }, []);

  const fetchProductTags = async () => {
    try {
      const response = await getProductTagApi({});
      const tagsData = response?.response?.data || response?.response || [];
      
      if (Array.isArray(tagsData)) {
        const tags = tagsData.map(tag => ({
          value: tag.id,
          label: tag.name
        }));
        setProductTagOptions(tags);
      }
    } catch (error) {
      console.error('Error fetching product tags:', error);
    }
  };

  const getVariantSku = (variant, productId, fallbackId = '') => {
    return variant.sku || `variant-${productId}-${variant.id || fallbackId}`;
  };

  const getVariantKey = (variant, productId, idx) => {
    return variant.id ? `variant-${productId}-${variant.id}-${idx}` : `variant-${productId}-${idx}`;
  };

  const handleSelectProduct = (productId) => {
    setSelectedProducts((prev) => {
      const isCurrentlySelected = prev.includes(productId);
      
      if (isCurrentlySelected) {
        setSelectedVariants((variants) => {
          const newVariants = { ...variants };
          delete newVariants[productId];
          return newVariants;
        });
        return prev.filter((id) => id !== productId);
      } else {
        const product = products.find(p => p.id === productId);
        if (product && product.variants && product.variants.length > 0) {
          const variantSkus = product.variants
            .filter(variant => {
              const itemStatus = variant.item_status || 'sent';
              return itemStatus !== 'approved' && itemStatus !== 'declined';
            })
            .map((variant, idx) => getVariantSku(variant, productId, idx));
          
          if (variantSkus.length > 0) {
            setSelectedVariants((variants) => ({
              ...variants,
              [productId]: variantSkus
            }));
            return [...prev, productId];
          }
        }
        return prev;
      }
    });
  };

  const handleSelectVariant = (productId, variantSku) => {
    const product = products.find(p => p.id === productId);
    if (product && product.variants) {
      const variant = product.variants.find((v, idx) => getVariantSku(v, productId, idx) === variantSku);
      if (variant) {
        const itemStatus = variant.item_status || 'sent';
        if (itemStatus === 'approved' || itemStatus === 'declined') {
          return;
        }
      }
    }

    setSelectedVariants((prev) => {
      const productVariants = prev[productId] || [];
      const isCurrentlySelected = productVariants.includes(variantSku);
      
      if (isCurrentlySelected) {
        setVariantDiscounts((discounts) => {
          if (!discounts[productId]) return discounts;
          const { [variantSku]: _, ...restVariants } = discounts[productId];
          if (Object.keys(restVariants).length === 0) {
            const { [productId]: __, ...restProducts } = discounts;
            return restProducts;
          }
          return {
            ...discounts,
            [productId]: restVariants
          };
        });
        return {
          ...prev,
          [productId]: productVariants.filter((sku) => sku !== variantSku),
        };
      } else {
        setVariantDiscounts((prev) => ({
          ...prev,
          [productId]: {
            ...(prev[productId] || {}),
            [variantSku]: globalDiscount || '',
          },
        }));
        return {
          ...prev,
          [productId]: [...productVariants, variantSku],
        };
      }
    });
  };

  const handleDiscountChange = (productId, variantSku, value) => {
    setVariantDiscounts((prev) => ({
      ...prev,
      [productId]: {
        ...(prev[productId] || {}),
        [variantSku]: value,
      },
    }));
  };

  const handleGlobalDiscountChange = (value) => {
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      const numVal = parseFloat(value);
      if (value === '' || (!isNaN(numVal) && numVal >= 0 && numVal <= 100)) {
        setGlobalDiscount(value);
        const updatedDiscounts = { ...variantDiscounts };
        Object.keys(selectedVariants).forEach(productId => {
          const variants = selectedVariants[productId] || [];
          variants.forEach(variantSku => {
            if (!updatedDiscounts[productId]) {
              updatedDiscounts[productId] = {};
            }
            updatedDiscounts[productId][variantSku] = value === '' ? '' : parseFloat(value).toFixed(2);
          });
        });
        setVariantDiscounts(updatedDiscounts);
      }
    }
  };

  const handleGlobalTagsChange = (selectedTags) => {
    setGlobalTags(selectedTags || []);
  };

  const handleApprove = async () => {
    if (!id) {
      toast.error('Invalid request ID', {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const invalidVariants = [];
    Object.keys(selectedVariants).forEach(productId => {
      const product = products.find(p => p.id === parseInt(productId));
      if (!product || !product.variants) return;
      
      const variants = selectedVariants[productId] || [];
      const productDiscounts = variantDiscounts[productId] || {};
      
      variants.forEach(variantSku => {
        const variant = product.variants.find((v, idx) => getVariantSku(v, productId, idx) === variantSku);
        if (!variant) return;
        
        const discount = productDiscounts[variantSku] || globalDiscount || '';
        if (discount) {
          const variantRrp = parseFloat(variant.rrp || 0);
          const variantCostPrice = parseFloat(variant.cost_price || 0);
          const discountNum = parseFloat(discount) || 0;
          
          if (variantRrp > 0 && variantCostPrice > 0) {
            const priceAfterDiscount = variantRrp * (1 - (discountNum / 100));
            if (priceAfterDiscount <= variantCostPrice) {
              invalidVariants.push({
                productTitle: product.title,
                variantSku: variant.sku || variantSku,
                discount: discountNum
              });
            }
          }
        }
      });
    });

    if (invalidVariants.length > 0) {
      const count = invalidVariants.length;
      const message = count === 1 
        ? `Discount too high. Sale price cannot be less than cost price for ${invalidVariants[0].variantSku}.`
        : `Discount too high. Sale price cannot be less than cost price for ${count} variant(s).`;
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 6000,
      });
      return;
    }

    setApproveLoading(true);
    try {
      const variantDiscountsData = {};
      Object.keys(selectedVariants).forEach(productId => {
        const variants = selectedVariants[productId] || [];
        const productDiscounts = variantDiscounts[productId] || {};
        variants.forEach(variantSku => {
          const discount = productDiscounts[variantSku] || globalDiscount || '';
          if (!variantDiscountsData[productId]) {
            variantDiscountsData[productId] = {};
          }
          variantDiscountsData[productId][variantSku] = discount ? parseFloat(discount) : null;
        });
      });

      const response = await approvePriceReductionRequestApi(id, {
        notes: priceReduction?.notes || '',
        discount: globalDiscount,
        tags: globalTags.map(tag => tag.value || tag.id),
        selected_variants: selectedVariants,
        variant_discounts: variantDiscountsData,
      });

      if (response.response && response.response.status) {
        toast.success(response.response.message || 'Price reduction request approved successfully!', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSelectedVariants({});
        setSelectedProducts([]);
        setGlobalDiscount('');
        setGlobalTags([]);
        fetchPriceReductionDetails();
      } else {
        toast.error(response.response?.message || 'Failed to approve price reduction request', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error('Error approving price reduction request:', error);
      toast.error(error.response?.data?.message || 'Failed to approve price reduction request', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setApproveLoading(false);
    }
  };

  const handleDecline = async () => {
    if (!id) {
      toast.error('Invalid request ID', {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (!Object.keys(selectedVariants).some(productId => (selectedVariants[productId] || []).length > 0)) {
      toast.error('Please select at least one variant to decline', {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setDeclineLoading(true);
    try {
      const response = await declinePriceReductionRequestApi(id, {
        notes: priceReduction?.notes || '',
        selected_variants: selectedVariants,
      });

      if (response.response && response.response.status) {
        toast.success(response.response.message || 'Price reduction request declined successfully!', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSelectedVariants({});
        setSelectedProducts([]);
        setGlobalDiscount('');
        setGlobalTags([]);
        fetchPriceReductionDetails();
      } else {
        toast.error(response.response?.message || 'Failed to decline price reduction request', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error('Error declining price reduction request:', error);
      toast.error(error.response?.data?.message || 'Failed to decline price reduction request', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setDeclineLoading(false);
    }
  };

  const fetchPriceReductionDetails = useCallback(() => {
    if (id) {
      setLoading(true);
      getPriceReductionRequestDetailsApi(id)
        .then((res) => {
          if (res.response) {
            setPriceReduction(res.response);
            if (res.response.products) {
              setAllProducts(res.response.products);
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching price reduction details:", error);
          setAllProducts([]);
          setLoading(false);
        });
    }
  }, [id]);

  useEffect(() => {
    fetchPriceReductionDetails();
  }, [fetchPriceReductionDetails]);

  useEffect(() => {
    if (!priceReduction || !allProducts.length) {
      setProducts([]);
      setTotalRows(0);
      return;
    }

    let filteredProducts = [...allProducts];
    
    filteredProducts = filteredProducts.filter(product => {
      if (!product.variants || product.variants.length === 0) {
        return false;
      }
      
      return product.variants.some(variant => {
        const itemStatus = variant.item_status || 'sent';
        
        if (activeTab === 'pending') {
          return itemStatus === 'sent';
        } else if (activeTab === 'approved') {
          return itemStatus === 'approved';
        } else if (activeTab === 'declined') {
          return itemStatus === 'declined';
        }
        return false;
      });
    });
    
    if (filterBrand?.value) {
      filteredProducts = filteredProducts.filter(p => 
        p.seller_brand_id === filterBrand.value
      );
    }
    
    if (filterCategory?.value) {
      filteredProducts = filteredProducts.filter(p => 
        p.category_id === filterCategory.value
      );
    }
    
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      filteredProducts = filteredProducts.filter(p => 
        p.title?.toLowerCase().includes(searchLower) ||
        p.style?.toLowerCase().includes(searchLower) ||
        p.variants?.some(v => v.sku?.toLowerCase().includes(searchLower))
      );
    }
    
    const total = filteredProducts.length;
    const offset = (page - 1) * pageSize;
    const paginatedProducts = filteredProducts.slice(offset, offset + pageSize);
    
    setProducts(paginatedProducts);
    setTotalRows(total);
  }, [activeTab, page, pageSize, filterBrand, filterCategory, searchText, priceReduction, allProducts]);

  const handleSelectAll = (checked) => {
    if (checked) {
      const allVariants = {};
      const selectedProductIds = [];
      
      products.forEach(product => {
        if (product.variants && product.variants.length > 0) {
          const variantSkus = product.variants
            .filter(variant => {
              const itemStatus = variant.item_status || 'sent';
              return itemStatus !== 'approved' && itemStatus !== 'declined';
            })
            .map((variant, idx) => getVariantSku(variant, product.id, idx));
          
          if (variantSkus.length > 0) {
            allVariants[product.id] = variantSkus;
            selectedProductIds.push(product.id);
          }
        }
      });
      
      setSelectedProducts(selectedProductIds);
      setSelectedVariants(allVariants);
    } else {
      setSelectedProducts([]);
      setSelectedVariants({});
    }
  };

  const ExpandedComponent = ({ data }) => {
    const productId = data.id;
    const allVariants = data.variants || [];
    
    const variants = allVariants.filter(variant => {
      const itemStatus = variant.item_status || 'sent';
      
      if (activeTab === 'pending') {
        return itemStatus === 'sent';
      } else if (activeTab === 'approved') {
        return itemStatus === 'approved';
      } else if (activeTab === 'declined') {
        return itemStatus === 'declined';
      }
      return false;
    });
    
    const productSelectedVariants = selectedVariants[productId] || [];
    const productDiscounts = variantDiscounts[productId] || {};
    const [localDiscounts, setLocalDiscounts] = useState({});
    
    const getDisplayDiscount = (variantSku, isSelected) => {
      if (localDiscounts[variantSku] !== undefined) {
        return localDiscounts[variantSku];
      }
      const specificDiscount = productDiscounts[variantSku];
      if (specificDiscount !== undefined && specificDiscount !== '') {
        return specificDiscount;
      }
      if (isSelected && globalDiscount) {
        return globalDiscount;
      }
      return '';
    };
    
    return (
      <div style={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
        <div style={{ backgroundColor: "#fff", borderRadius: "4px", overflow: "hidden" }}>
          <table style={{ width: "100%", fontSize: "11px", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f5f5f5", borderBottom: "1px solid #e0e0e0" }}>
                {activeTab === 'pending' && (
                  <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px", width: "30px" }}></th>
                )}
                <th style={{ padding: "10px", textAlign: "left", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>SKU</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Goddiva Qty</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>CG Portal Qty</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Total Qty</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Cost Price</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>RRP</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Sale Price</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Sold</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Return</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Sale</th>
                <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Discount(%)</th>
                {activeTab === 'pending' && (
                  <th style={{ padding: "10px", textAlign: "center", fontWeight: "bold", color: "#68646d", fontSize: "12px" }}>Price after Discount</th>
                )}
              </tr>
            </thead>
            <tbody>
              {variants.length > 0 ? (
                variants.map((variant, index) => {
                  const variantSku = getVariantSku(variant, productId, index);
                  const variantKey = getVariantKey(variant, productId, index);
                  const isSelected = productSelectedVariants.includes(variantSku);
                  const itemStatus = variant.item_status || 'sent';
                  const isProcessed = itemStatus === 'approved' || itemStatus === 'declined';
                  const statusColor = itemStatus === 'approved' ? '#28a745' : itemStatus === 'declined' ? '#dc3545' : '#6c757d';
                  const statusText = itemStatus === 'approved' ? 'Approved' : itemStatus === 'declined' ? 'Declined' : 'Pending';
                  
                  const discountValue = activeTab === 'pending' && isSelected 
                    ? getDisplayDiscount(variantSku, isSelected) || variant.discount || ''
                    : variant.discount || '';
                  
                  const variantRrp = parseFloat(variant.rrp || 0);
                  const variantCostPrice = parseFloat(variant.cost_price || 0);
                  const discountNum = discountValue === '' ? 0 : parseFloat(discountValue) || 0;
                  const priceAfterDiscount = discountNum > 0 && variantRrp > 0 
                    ? variantRrp * (1 - (discountNum / 100)) 
                    : null;
                  const isInvalidDiscount = priceAfterDiscount !== null && priceAfterDiscount <= variantCostPrice && variantCostPrice > 0;
                  
                  return (
                    <React.Fragment key={variantKey}>
                      <tr style={{ borderBottom: isInvalidDiscount ? "none" : "1px solid #e0e0e0", backgroundColor: isProcessed ? '#f8f9fa' : '#fff' }}>
                        {activeTab === 'pending' && (
                          <td style={{ padding: "10px", textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              disabled={isProcessed}
                              onChange={() => handleSelectVariant(productId, variantSku)}
                              style={{ opacity: isProcessed ? 0.5 : 1, cursor: isProcessed ? 'not-allowed' : 'pointer' }}
                            />
                          </td>
                        )}
                        <td style={{ padding: "10px", textAlign: "left" }}>
                          {variant.sku || "-"}
                          {isProcessed && (
                            <span style={{ marginLeft: "8px", fontSize: "10px", color: statusColor, fontWeight: "bold" }}>
                              ({statusText})
                            </span>
                          )}
                        </td>
                        <td style={{ padding: "10px", textAlign: "center" }}>{variant.goddiva_qty || 0}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>{variant.cg_portal_qty || 0}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>{variant.total_qty || 0}</td>
                        <td style={{ padding: "10px", textAlign: "center", color: isInvalidDiscount ? "#c62828" : "inherit" }}>£{variantCostPrice.toFixed(2)}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>£{variantRrp.toFixed(2)}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>£{parseFloat(variant.sale_price || 0).toFixed(2)}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>{variant.sold || 0}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>{variant.returned || 0}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>{variant.sale || 0}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>
                          {activeTab === 'pending' && isSelected && !isProcessed ? (
                            <input
                              type="text"
                              value={discountValue}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === '' || /^\d*\.?\d*$/.test(val)) {
                                  setLocalDiscounts(prev => ({
                                    ...prev,
                                    [variantSku]: val
                                  }));
                                }
                              }}
                              onBlur={(e) => {
                                const val = e.target.value.trim();
                                setLocalDiscounts(prev => {
                                  const { [variantSku]: _, ...rest } = prev;
                                  return rest;
                                });
                                
                                if (val === '') {
                                  handleDiscountChange(productId, variantSku, '');
                                  return;
                                }
                                
                                const numVal = parseFloat(val);
                                const finalValue = (!isNaN(numVal) && numVal >= 0 && numVal <= 100) 
                                  ? numVal.toFixed(2) 
                                  : '';
                                handleDiscountChange(productId, variantSku, finalValue);
                              }}
                              placeholder="%"
                              style={{
                                width: "60px",
                                padding: "4px",
                                textAlign: "center",
                                border: isInvalidDiscount ? "1px solid #dc3545" : "1px solid #e0e0e0",
                                borderRadius: "4px",
                                fontSize: "11px"
                              }}
                            />
                          ) : (
                            <span>{variant.discount ? parseFloat(variant.discount).toFixed(2) + "%" : "-"}</span>
                          )}
                        </td>
                        {activeTab === 'pending' && (
                          <td style={{ padding: "10px", textAlign: "center", color: isInvalidDiscount ? "#c62828" : "inherit" }}>
                            {priceAfterDiscount !== null ? `£${priceAfterDiscount.toFixed(2)}` : '-'}
                          </td>
                        )}
                      </tr>
                      {activeTab === 'pending' && isInvalidDiscount && (
                        <tr>
                          <td colSpan="5" style={{ padding: "0", borderBottom: "1px solid #e0e0e0" }}></td>
                          <td style={{ padding: "0px 10px 4px 10px", textAlign: "center", borderBottom: "1px solid #e0e0e0" }}>
                            <div style={{ 
                              color: "#c62828", 
                              fontSize: "9px", 
                              fontWeight: "bold",
                              textAlign: "center",
                              lineHeight: "1.3",
                              marginTop: "-8px"
                            }}>
                              <div>Warning: Discount</div>
                              <div>exceeds cost price!</div>
                            </div>
                          </td>
                          <td colSpan="7" style={{ padding: "0", borderBottom: "1px solid #e0e0e0" }}></td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={activeTab === 'pending' ? "13" : "11"} style={{ padding: "20px", textAlign: "center", color: "#666", fontSize: "11px" }}>
                    No variants available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const tableColumns = [
    ...(activeTab === 'pending' ? [{
      name: (
        <input
          type="checkbox"
          checked={products.length > 0 && selectedProducts.length === products.length}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      selector: (row) => (
        <input
          type="checkbox"
          checked={selectedProducts.includes(row.id)}
          onChange={() => handleSelectProduct(row.id)}
        />
      ),
      width: "30px",
      minWidth: "30px",
      sortable: false,
      center: true,
    }] : []),
    {
      name: "Title",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={row.image || "/default-product.png"}
            alt={row.title}
            style={{ width: "40px", height: "40px", marginRight: "10px", objectFit: "cover" }}
          />
          <span>{row.title}</span>
        </div>
      ),
      sortable: true,
      wrap: true,
      minWidth: "200px",
      grow: 3,
    },
    {
      name: "Style",
      selector: (row) => (
        <div>
          <div>{row.style}</div>
          <div style={{ fontSize: "11px", color: "#666" }}>
            {row.status === "active" ? (
              <span style={{ color: "green" }}>(Active)</span>
            ) : (
              <span style={{ color: "red" }}>(Inactive)</span>
            )}
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "120px",
      grow: 1,
    },
    {
      name: "Current Qty",
      selector: (row) => row.current_qty,
      sortable: true,
      center: true,
      minWidth: "80px",
      width: "80px",
    },
    {
      name: "Cost P..",
      selector: (row) => `£${parseFloat(row.cost_price || 0).toFixed(2)}`,
      sortable: true,
      right: true,
      minWidth: "85px",
      width: "85px",
    },
    {
      name: "RRP",
      selector: (row) => `£${parseFloat(row.rrp || 0).toFixed(2)}`,
      sortable: true,
      right: true,
      minWidth: "75px",
      width: "75px",
    },
    {
      name: "Sale P..",
      selector: (row) => `£${parseFloat(row.sale_price || 0).toFixed(2)}`,
      sortable: true,
      right: true,
      minWidth: "85px",
      width: "85px",
    },
    {
      name: "Total Sold",
      selector: (row) => row.total_sold || 0,
      sortable: true,
      center: true,
      minWidth: "85px",
      width: "85px",
    },
    {
      name: "Grade",
      selector: (row) => row.grade || "-",
      sortable: true,
      center: true,
      minWidth: "80px",
      width: "80px",
    },
    {
      name: "Generated By",
      selector: (row) => row.generated_by || "-",
      sortable: true,
      center: false,
      minWidth: "120px",
      grow: 1,
    },
    {
      name: "Generate At",
      selector: (row) => row.generate_at ? moment(row.generate_at).format("DD/MM/YYYY HH:mm:ss") : "-",
      sortable: true,
      center: false,
      minWidth: "150px",
      width: "150px",
    },
    {
      name: "Tags",
      selector: (row) => {
        const tags = row.tags || [];
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", maxWidth: "200px", overflow: "hidden" }}>
            {tags.slice(0, 3).map((tag, idx) => (
              <span
                key={idx}
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "2px 6px",
                  borderRadius: "3px",
                  fontSize: "10px",
                  color: "#666",
                }}
              >
                {tag}
              </span>
            ))}
            {tags.length > 3 && (
              <span style={{ fontSize: "10px", color: "#999" }}>+{tags.length - 3}</span>
            )}
          </div>
        );
      },
      sortable: false,
      center: false,
      minWidth: "150px",
      width: "200px",
      maxWidth: "200px",
      grow: 0,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb title="Price Reduction Request View" data={dataMenu} />
      <Container fluid={true} className="product-wrapper">
        <div className="product-grid">
          <div className="feature-products">
            <style>
              {`
                .product-table .rdt_TableHeader {
                  min-height: 40px !important;
                }
                .product-table .rdt_TableCol {
                  padding: 8px 5px !important;
                  height: auto !important;
                  min-height: 40px !important;
                  display: flex !important;
                  align-items: center !important;
                  font-size: 12px !important;
                  font-weight: bold !important;
                  color: #68646d !important;
                }
                .product-table .rdt_TableCol:first-child {
                  padding: 8px 0px !important;
                  width: 20px !important;
                  min-width: 20px !important;
                  max-width: 20px !important;
                }
                .product-table .rdt_TableCell:first-child {
                  padding: 5px 0px !important;
                  width: 20px !important;
                }
                .product-table .rdt_TableCell {
                  font-size: 11px !important;
                  padding: 5px !important;
                  overflow: hidden !important;
                  text-overflow: ellipsis !important;
                }
                .product-table .rdt_TableRow {
                  font-size: 11px !important;
                }
                .product-table .rdt_TableCol[data-column-id="tags"],
                .product-table .rdt_TableCell[data-column-id="tags"] {
                  width: 200px !important;
                  min-width: 200px !important;
                  max-width: 200px !important;
                  overflow: hidden !important;
                }
                .product-tag-selector-wrapper {
                  width: 100%;
                  max-width: 100%;
                  overflow: visible;
                  position: relative;
                }
                .product-tag-selector-wrapper .product-tag-selector > div {
                  max-height: 80px !important;
                  overflow-y: auto !important;
                  overflow-x: hidden !important;
                }
                .product-tag-selector-wrapper .product-tag-selector [class*="ValueContainer"],
                .product-tag-selector-wrapper .product-tag-selector [class*="valueContainer"],
                .product-tag-selector-wrapper .product-tag-selector [class*="css-"] {
                  max-height: 80px !important;
                  overflow-y: auto !important;
                  overflow-x: hidden !important;
                  display: flex !important;
                  flex-wrap: wrap !important;
                  -webkit-overflow-scrolling: touch !important;
                  pointer-events: auto !important;
                }
                .product-tag-selector-wrapper .product-tag-selector[class*="--is-disabled"] [class*="ValueContainer"],
                .product-tag-selector-wrapper .product-tag-selector[class*="--is-disabled"] [class*="valueContainer"],
                .product-tag-selector-wrapper .product-tag-selector[class*="--is-disabled"] > div > div {
                  overflow-y: auto !important;
                  pointer-events: auto !important;
                  cursor: default !important;
                  -webkit-overflow-scrolling: touch !important;
                }
                .product-tag-selector-wrapper .product-tag-selector[class*="--is-disabled"] {
                  pointer-events: none !important;
                }
                .product-tag-selector-wrapper .product-tag-selector[class*="--is-disabled"] [class*="ValueContainer"],
                .product-tag-selector-wrapper .product-tag-selector[class*="--is-disabled"] [class*="valueContainer"] {
                  pointer-events: auto !important;
                }
                .product-tag-selector-wrapper .product-tag-selector [class*="ValueContainer"]::-webkit-scrollbar,
                .product-tag-selector-wrapper .product-tag-selector [class*="valueContainer"]::-webkit-scrollbar {
                  width: 6px !important;
                }
                .product-tag-selector-wrapper .product-tag-selector [class*="ValueContainer"]::-webkit-scrollbar-track,
                .product-tag-selector-wrapper .product-tag-selector [class*="valueContainer"]::-webkit-scrollbar-track {
                  background: #f1f1f1 !important;
                  border-radius: 3px !important;
                }
                .product-tag-selector-wrapper .product-tag-selector [class*="ValueContainer"]::-webkit-scrollbar-thumb,
                .product-tag-selector-wrapper .product-tag-selector [class*="valueContainer"]::-webkit-scrollbar-thumb {
                  background: #888 !important;
                  border-radius: 3px !important;
                }
                .product-tag-selector-wrapper .product-tag-selector [class*="ValueContainer"]::-webkit-scrollbar-thumb:hover,
                .product-tag-selector-wrapper .product-tag-selector [class*="valueContainer"]::-webkit-scrollbar-thumb:hover {
                  background: #555 !important;
                }
                .price-reduction-tabs {
                  background-color: transparent;
                  border-bottom: none;
                  display: flex;
                  width: 100%;
                }
                .price-reduction-tabs .nav-item {
                  flex: 1;
                }
                .price-reduction-tabs .nav-link {
                  color: #68646d !important;
                  background-color: transparent !important;
                  border: none !important;
                  padding: 10px 20px;
                  margin-right: 0;
                  border-radius: 0;
                  width: 100%;
                  text-align: center;
                }
                .price-reduction-tabs .nav-link.active {
                  background-color: #3e4a56 !important;
                  color: #ffffff !important;
                }
                .price-reduction-tabs .nav-link:not(.active) {
                  color: #68646d !important;
                  background-color: transparent !important;
                }
                .price-reduction-tabs .nav-link:not(.active):hover {
                  color: #3e4a56 !important;
                  background-color: transparent !important;
                }
                .price-reduction-tabs .nav-link:focus,
                .price-reduction-tabs .nav-link:active,
                .price-reduction-tabs .nav-link:focus-visible {
                  outline: none !important;
                  box-shadow: none !important;
                  color: #ffffff !important;
                  background-color: #3e4a56 !important;
                }
                .price-reduction-tabs .nav-link.active:focus,
                .price-reduction-tabs .nav-link.active:active,
                .price-reduction-tabs .nav-link.active:focus-visible {
                  color: #ffffff !important;
                  background-color: #3e4a56 !important;
                }
                .price-reduction-tabs a {
                  text-decoration: none !important;
                  color: inherit !important;
                }
                .price-reduction-tabs a:hover,
                .price-reduction-tabs a:focus,
                .price-reduction-tabs a:active {
                  text-decoration: none !important;
                  color: inherit !important;
                }
                .filter-card {
                  background-color: #ffffff;
                  border-radius: 0;
                  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
              `}
            </style>
            <Card className="mb-3 filter-card" style={{ marginBottom: "1rem", borderRadius: "0", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
              <CardBody style={{ padding: "4px 8px" }}>
                <Row className="align-items-center" style={{ gap: "12px", flexWrap: "wrap" }}>
                  <Col md="auto" style={{ paddingRight: "0", flex: "1 1 0", minWidth: "150px" }}>
                    <Select
                      className="select2-filter"
                      isClearable
                      value={filterBrand}
                      placeholder="Brand"
                      options={filterOptions.brands}
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e) => {
                        setFilterBrand(e);
                        setPage(1);
                      }}
                    />
                  </Col>
                  <Col md="auto" style={{ paddingRight: "0", flex: "1 1 0", minWidth: "150px" }}>
                    <Select
                      className="select2-filter"
                      isClearable
                      value={filterCategory}
                      placeholder="Category"
                      options={filterOptions.categories}
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e) => {
                        setFilterCategory(e);
                        setPage(1);
                      }}
                    />
                  </Col>
                  <Col md="auto" style={{ paddingRight: "0", flex: "1 1 0", minWidth: "300px" }}>
                    <Form style={{ width: "100%" }}>
                      <FormGroup className="m-0" style={{ position: "relative" }}>
                        <Input
                          className="form-control"
                          type="text"
                          placeholder="Search Product Name / Style / SKU / Barcode"
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            setPage(1);
                          }}
                          style={{
                            paddingRight: "40px",
                            border: "none",
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          }}
                        />
                        <i
                          className="fa fa-search"
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#9e9e9e",
                            cursor: "pointer",
                          }}
                        ></i>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {priceReduction && (
              <div style={{ marginBottom: "1rem", fontSize: "14px", color: "#333", fontWeight: "normal" }}>
                <strong>Requested By :</strong> {priceReduction.requested_by || "N/A"}{" "}
                <strong>Requested Date:</strong> {priceReduction.requested_date || "N/A"}
              </div>
            )}

            <Card className="mb-3" style={{ marginBottom: "1rem" }}>
              <CardBody style={{ padding: "0" }}>
                <Nav tabs className="price-reduction-tabs">
                  <NavItem>
                    <NavLink
                      className={activeTab === "pending" ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        try {
                          setActiveTab("pending");
                          setPage(1);
                        } catch (error) {
                          console.error("Error switching to pending tab:", error);
                        }
                      }}
                    >
                      Pending
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "approved" ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        try {
                          setActiveTab("approved");
                          setPage(1);
                        } catch (error) {
                          console.error("Error switching to approved tab:", error);
                        }
                      }}
                    >
                      Approved
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "declined" ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        try {
                          setActiveTab("declined");
                          setPage(1);
                        } catch (error) {
                          console.error("Error switching to declined tab:", error);
                        }
                      }}
                    >
                      Declined
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardBody>
            </Card>

            <Card>
              <CardBody style={{ paddingLeft: "1rem", paddingRight: "1rem", paddingTop: "1rem", paddingBottom: "1rem" }}>
                {activeTab === 'pending' && Object.keys(selectedVariants).some(productId => (selectedVariants[productId] || []).length > 0) && (
                  <Row style={{ gap: "12px", flexWrap: "nowrap", marginBottom: "1rem", padding: "0", justifyContent: "flex-end", alignItems: "flex-end", marginLeft: "0", marginRight: "0" }}>
                    <Col md="auto" style={{ paddingRight: "0", paddingLeft: "0", flex: "0 0 auto", minWidth: "150px" }}>
                      <FormGroup className="m-0">
                        <label style={{ fontSize: "12px", fontWeight: "bold", color: "#68646d", marginBottom: "0px", display: "block" }}>
                          Discount(%)
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter discount"
                          value={globalDiscount}
                          onChange={(e) => handleGlobalDiscountChange(e.target.value)}
                          onBlur={(e) => {
                            const val = parseFloat(e.target.value);
                            if (!isNaN(val) && val >= 0 && val <= 100) {
                              setGlobalDiscount(val.toFixed(2));
                            } else if (e.target.value.trim() === '') {
                              setGlobalDiscount('');
                            }
                          }}
                          style={{
                            minHeight: "38px",
                            fontSize: "14px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "4px"
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="auto" style={{ paddingRight: "0", paddingLeft: "0", flex: "0 0 auto", minWidth: "250px", maxWidth: "300px" }}>
                      <FormGroup className="m-0">
                        <label style={{ fontSize: "12px", fontWeight: "bold", color: "#68646d", marginBottom: "0px", display: "block" }}>
                          Tags
                        </label>
                        <div style={{ width: '100%', maxWidth: '300px', overflow: 'hidden' }}>
                          <ProductTagSelector
                            productId="global"
                            selectedTags={globalTags}
                            tagOptions={productTagOptions}
                            onTagChange={(productId, selectedTags) => {
                              handleGlobalTagsChange(selectedTags);
                            }}
                            onCreateTag={() => {}}
                            isDisabled={false}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="auto" style={{ paddingRight: "0", paddingLeft: "0", flex: "0 0 auto" }}>
                      <Button
                        color="success"
                        onClick={handleApprove}
                        disabled={approveLoading}
                        style={{
                          minHeight: "38px",
                          minWidth: "100px",
                          padding: "8px 32px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginRight: "10px"
                        }}
                      >
                        {approveLoading ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-1" />
                            Approving...
                          </>
                        ) : (
                          'Approve'
                        )}
                      </Button>
                      <Button
                        color="danger"
                        onClick={handleDecline}
                        disabled={declineLoading}
                        style={{
                          minHeight: "38px",
                          minWidth: "100px",
                          padding: "8px 32px",
                          fontSize: "14px",
                          fontWeight: "bold"
                        }}
                      >
                        {declineLoading ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-1" />
                            Declining...
                          </>
                        ) : (
                          'Decline'
                        )}
                      </Button>
                    </Col>
                  </Row>
                )}
                <div className="product-table" style={{ width: "100%", overflowX: "hidden", margin: "0", marginTop: Object.keys(selectedVariants).some(productId => (selectedVariants[productId] || []).length > 0) ? "1rem" : "0.5rem" }}>
                  <CommonDataTable
                    headerColumns={tableColumns}
                    gridData={products}
                    noAction
                    progressPending={loading}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    paginationDefaultPage={page}
                    paginationPerPage={pageSize}
                    onChangePage={(page) => setPage(page)}
                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                      setPageSize(currentRowsPerPage);
                      setPage(currentPage);
                    }}
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    onRowExpandToggled={(expanded, row) => {
                      setExpandedRows((prev) => ({
                        ...prev,
                        [row.id]: expanded,
                      }));
                    }}
                    expandableIcon={{
                      collapsed: <i className="fa fa-chevron-right" style={{ fontSize: "12px", color: "#68646d" }} />,
                      expanded: <i className="fa fa-chevron-down" style={{ fontSize: "12px", color: "#68646d" }} />,
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ product: productReducer }])(PriceReductionRequestView);

